import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from '../utils/propTypes';
import classNames from 'classnames';
import ProfileImg from '../assets/img/users/profile.png';
// import lib
import isEmpty from '../lib/isEmpty';

const Avatar = ({
  rounded,
  circle,
  src,
  size,
  tag: Tag,
  className,
  style,
  ...restProps
}) => {
  const { profile } = useSelector(state => state.profile)
  // console.log(profile, 'profileprofileprofile')
  const classes = classNames({ 'rounded-circle': circle, rounded }, className);
  return (
    <Tag
      src={isEmpty(profile) ? src : profile}
      style={{ width: size, height: size, ...style }}
      className={classes}
      {...restProps}
    />
  );
};

Avatar.propTypes = {
  tag: PropTypes.component,
  rounded: PropTypes.bool,
  circle: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  src: PropTypes.string,
  style: PropTypes.object,
};

Avatar.defaultProps = {
  tag: 'img',
  rounded: false,
  circle: true,
  size: 40,
  src: ProfileImg,
  style: {},
};

export default Avatar;
